<p-dialog header="Default Booking Fee Already Set" [(visible)]="showDefaultWarning" [style]="{width: '480px'}" [modal]="true" [baseZIndex]="10000" [closable]="false">
  <div style="display:flex; align-items:flex-start; gap:16px; padding: 8px 0 16px;">
    <span class="pi pi-exclamation-triangle" style="color:#f59e0b; font-size:2rem; flex-shrink:0; margin-top:2px;"></span>
    <div>
      <p style="margin:0 0 8px; font-size:1rem;">There is already a default Booking Fee set:</p>
      <p style="margin:0 0 12px; font-weight:600; font-size:1rem;">{{existingDefaultName}}</p>
      <p style="margin:0; color:#6b7280;">Setting this as default will replace it. Do you want to continue?</p>
    </div>
  </div>
  <ng-template #footer>
    <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="confirmReplaceDefault()">
      <span class="pi pi-check" style="margin-right:8px;"></span>Yes, replace it
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-outlined p-button-secondary" style="margin-left:8px;" (click)="showDefaultWarning = false">
      <span class="pi pi-times" style="margin-right:8px;"></span>Cancel
    </button>
  </ng-template>
</p-dialog>

@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid; border-radius: 6px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 10px;">
      You don't have access to this function
    </h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3"><h3>Booking Fees</h3></div>
    <div class="surface-card p-4 shadow-2 border-round">
      <div class="grid formgrid">
        <app-tabview [style]="{'width':'100%'}">
          <!-- ── Packages tab ─────────────────────────────────────────── -->
          <app-tabpanel header="Packages" leftIcon="pi pi-box">
            <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
              <span class="pi pi-info-circle" style="margin-right:2px;"></span>
              Assign a booking fee to each package. If no fee is assigned, the default booking fee will be used.
            </p>
            <p-table #pkgTable
              [value]="packages"
              sortField="name"
              [paginator]="true"
              [rows]="10"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              [rowsPerPageOptions]="[10,25,50]"
              responsiveLayout="scroll"
              style="width:100%">
              <ng-template #header>
                <tr>
                  <th style="width:220px;">Assigned Fee</th>
                  <th pSortableColumn="name">Package <p-sorticon field="name"></p-sorticon></th>
                  <th style="width:300px;">Change</th>
                </tr>
              </ng-template>
              <ng-template #body let-pkg>
                <tr>
                  <td>
                    @if (pkg._bookingfeeid) {
                      <span
                        style="display:inline-flex; align-items:center; gap:6px; padding:3px 10px; border-radius:12px; font-size:0.8rem; font-weight:500; cursor:default;"
                        [style.border]="'1px solid ' + getFeeColour(pkg._bookingfeeid)"
                        [style.background]="getFeeColour(pkg._bookingfeeid) + '22'">
                        <span style="display:inline-block; width:10px; height:10px; border-radius:50%;"
                        [style.background-color]="getFeeColour(pkg._bookingfeeid)"></span>
                        <span>{{ getFeeName(pkg._bookingfeeid) }}</span>
                      </span>
                    }
                    @if (!pkg._bookingfeeid) {
                      <span class="text-500 text-sm">None</span>
                    }
                  </td>
                  <td>{{ pkg.name }}</td>
                  <td>
                    <p-select
                      [options]="feeDropdownOptions"
                      [(ngModel)]="pkg._bookingfeeid"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="No booking fee"
                      [showClear]="true"
                      [style]="{'width':'280px'}"
                      (onChange)="onFeeChange(pkg)">
                    </p-select>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr><td colspan="3" class="text-center text-600 py-4">No packages found.</td></tr>
              </ng-template>
            </p-table>
          </app-tabpanel>
          <!-- ── Booking Fees tab ────────────────────────────────────── -->
          <app-tabpanel header="Booking Fees" leftIcon="pi pi-credit-card">
            <!-- LIST VIEW -->
            @if (!editingFee) {
              <div class="flex align-items-center justify-content-between mb-4">
                <p class="m-0 p-0 text-600 line-height-3">
                  <span class="pi pi-info-circle mr-1"></span>
                  Booking Fees can be added onto a customer's purchase to help recover the cost of processing the transaction.
                </p>
                <div class="flex gap-2 ml-3 flex-shrink-0">
                  <p-togglebutton
                    [(ngModel)]="isDisabled"
                    onLabel="Show Disabled"
                    offLabel="Hide Disabled"
                    offIcon="pi pi-times"
                    onIcon="pi pi-check"
                    [style]="{'color':'white','background-color':'#EF4444','height':'50px'}"
                    (click)="toggleDisabled()">
                  </p-togglebutton>
                  <button pButton type="button" style="height:50px;" class="p-button-sm p-button-success" (click)="addNew()">
                    <span class="pi pi-plus" style="margin-right:8px;"></span>
                    <span>Add New</span>
                  </button>
                </div>
              </div>
              <p-table #feeTable
                [value]="listBookingFees"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                [rowsPerPageOptions]="[10,25,50]"
                responsiveLayout="scroll">
                <ng-template #header>
                  <tr>
                    <th width="40px"></th>
                    <th width="24%">Name</th>
                    <th width="20%">Public Fee</th>
                    <th width="20%">Admin Fee</th>
                    <th width="10%">Public Applies</th>
                    <th width="10%">Admin Applies</th>
                    <th width="8%"></th>
                    <th width="8%"></th>
                  </tr>
                </ng-template>
                <ng-template #body let-data>
                  <tr [ngStyle]="{'background-color': data.disabled ? '#fee' : (data.isdefault ? '#e8f4fd' : '#ffffff')}">
                    <td>
                      <span style="display:inline-block; width:24px; height:24px; border-radius:4px;"
                      [style.background-color]="data.colour || '#4CAF50'"></span>
                    </td>
                    <td>
                      @if (data.isdefault) {
                        <strong>{{data.name}}</strong>
                      }
                      @if (!data.isdefault) {
                        <span>{{data.name}}</span>
                      }
                      @if (data.isdefault) {
                        <span style="display:inline-block; margin-left:8px; background-color:#0ea5e9; color:white; padding:2px 10px; border-radius:4px; font-size:0.75rem; font-weight:600; letter-spacing:0.03em;">Default</span>
                      }
                    </td>
                    <td>
                      @if (data.bfpublicapply) {
                        <span>{{feeDisplay(data.bfpublictype, data.bfpublicfee)}}</span>
                      }
                      @if (!data.bfpublicapply) {
                        <span class="text-400">Not applied</span>
                      }
                    </td>
                    <td>
                      @if (data.bfadminapply) {
                        <span>{{feeDisplay(data.bfadmintype, data.bfadminfee)}}</span>
                      }
                      @if (!data.bfadminapply) {
                        <span class="text-400">Not applied</span>
                      }
                    </td>
                    <td>
                      <span [class]="data.bfpublicapply ? 'pi pi-check' : 'pi pi-times'"
                      [style.color]="data.bfpublicapply ? 'green' : 'red'"></span>
                    </td>
                    <td>
                      <span [class]="data.bfadminapply ? 'pi pi-check' : 'pi pi-times'"
                      [style.color]="data.bfadminapply ? 'green' : 'red'"></span>
                    </td>
                    <td>
                      <button pButton type="button" class="p-button-sm p-button-success" (click)="editData(data.bfid)">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>Edit
                      </button>
                    </td>
                    <td>
                      <button pButton type="button" class="p-button-sm p-button-danger" (click)="disableData(data.bfid)">
                        <span class="pi pi-trash" style="margin-right:8px;"></span>Disable
                      </button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr><td colspan="8" class="text-center text-600 py-4">No booking fees found. Click <strong>Add New</strong> to create one.</td></tr>
                </ng-template>
              </p-table>
            }
            <!-- EDIT VIEW -->
            @if (editingFee) {
              <!-- Back bar -->
              <div class="flex justify-content-end mb-4">
                <button pButton type="button" class="p-button p-button-sm p-button-outlined" (click)="backToList()">
                  <span class="pi pi-angle-left" style="margin-right:8px;"></span>
                  <span>Back to List</span>
                </button>
              </div>
              <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                Booking Fees can be added onto a customer's purchase to help recover the cost of processing the transaction. The booking fee is always in addition to the deposit amount.
              </p>
              <div class="surface-card p-4 shadow-2 border-round">
                <div class="grid formgrid p-fluid">
                  <div class="field mb-4 col-12">
                    <label for="feename" class="font-medium">Name</label>
                    <input id="feename" [(ngModel)]="BookingFee.name" type="text" pInputText>
                  </div>
                  <div class="field mb-4 col-12">
                    <label class="font-medium">Colour</label>
                    <div class="flex align-items-center gap-3">
                      <p-colorpicker [(ngModel)]="BookingFee.colour" format="hex"></p-colorpicker>
                      <input pInputText [(ngModel)]="BookingFee.colour"
                        #feeColourInput="ngModel"
                        pattern="^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$"
                        placeholder="#RRGGBB"
                        class="w-8rem text-sm font-mono"
                        [ngClass]="{'ng-invalid ng-dirty': feeColourInput.invalid && feeColourInput.dirty}" />
                        @if (feeColourInput.invalid && feeColourInput.dirty) {
                          <small class="p-error">
                            Must be a valid hex colour (e.g. #FF5733)
                          </small>
                        }
                      </div>
                    </div>
                    <div class="field mb-4 col-12">
                      <label class="font-medium">Default Booking Fee</label>
                      <p-selectbutton [(ngModel)]="BookingFee.isdefault" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                    </div>
                    <!-- The public and admin blocks ask several of the same questions,
                    so each is banded, titled, and has its questions name their own
                    side. Two identical labels one above the other read as a
                    duplicate otherwise. -->
                    <div class="col-12">
                      <div class="fee-section fee-section--public">
                        <div class="fee-section-head">
                          <span class="pi pi-globe"></span>
                          <div>
                            <h4>Public Booking Fee</h4>
                            <span>Charged on bookings customers make themselves online.</span>
                          </div>
                        </div>
                        <div class="grid formgrid p-fluid">
                          <div class="field mb-4 col-12">
                            <label class="font-medium">Apply Public Booking Fee</label>
                            <p-selectbutton [(ngModel)]="BookingFee.bfpublicapply" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                          </div>
                          @if (BookingFee.bfpublicapply) {
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Public Booking Fee Type</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bfpublictype" [style]="{'width': '400px'}" [options]="stateOptionsType"></p-selectbutton>
                            </div>
                            @if (BookingFee.bfpublictype !== 'PERCENTAGE') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Public Booking Fee Amount</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfpublicfee" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="100" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                            }
                            @if (BookingFee.bfpublictype === 'PERCENTAGE') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Public Booking Fee Amount</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfpublicfee" [style]="{'width': '400px'}" suffix="%" [showButtons]="true" [max]="100" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                            }
                            @if (BookingFee.bfpublictype !== 'FIXED') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Public Booking Fee Min</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfpublicmin" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="9999" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Public Booking Fee Max</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfpublicmax" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="9999" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                              @if (!publicMinMaxValid) {
                                <div class="text-danger" style="margin-left:10px; margin-top:-23px;">
                                  <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Public Booking Fee Max must be greater than the Min.
                                </div>
                              }
                            }
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Public Booking Fee is applied to Bookings made by Members</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliestomemberspublic" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                            </div>
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Public Booking Fee is applied when purchasing Memberships</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliedonmembershippurchasespublic" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="fee-section fee-section--admin">
                        <div class="fee-section-head">
                          <span class="pi pi-users"></span>
                          <div>
                            <h4>Admin Booking Fee</h4>
                            <span>Charged on bookings your own staff take in-venue.</span>
                          </div>
                        </div>
                        <div class="grid formgrid p-fluid">
                          <div class="field mb-4 col-12">
                            <label class="font-medium">Apply Admin Booking Fee</label>
                            <p-selectbutton [(ngModel)]="BookingFee.bfadminapply" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                          </div>
                          @if (BookingFee.bfadminapply) {
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Admin Booking Fee Type</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bfadmintype" [style]="{'width': '400px'}" [options]="stateOptionsType"></p-selectbutton>
                            </div>
                            @if (BookingFee.bfadmintype !== 'PERCENTAGE') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Admin Booking Fee Amount</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfadminfee" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="9999" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                            }
                            @if (BookingFee.bfadmintype === 'PERCENTAGE') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Admin Booking Fee Amount</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfadminfee" [style]="{'width': '400px'}" suffix="%" [showButtons]="true" [max]="9999" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                            }
                            @if (BookingFee.bfadmintype !== 'FIXED') {
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Admin Booking Fee Min</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfadminmin" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="100" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                              <div class="field mb-4 col-12">
                                <label class="font-medium">Admin Booking Fee Max</label>
                                <p-inputnumber [(ngModel)]="BookingFee.bfadminmax" [style]="{'width': '400px'}" mode="currency" [currency]="CurrencySymbol" [showButtons]="true" [max]="100" [min]="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                              </div>
                              @if (!adminMinMaxValid) {
                                <div class="text-danger" style="margin-left:10px; margin-top:-23px;">
                                  <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Admin Booking Fee Max must be greater than the Min.
                                </div>
                              }
                            }
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Admin Booking Fee is applied to Bookings made by Members</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliestomembersadmin" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                            </div>
                            <div class="field mb-4 col-12">
                              <label class="font-medium">Admin Booking Fee is applied when purchasing Memberships</label>
                              <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliedonmembershippurchasesadmin" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-12 flex justify-content-end gap-2 mt-3">
                      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto" (click)="updateData()">
                        <span class="pi pi-save" style="margin-right:8px;"></span>Save Changes
                      </button>
                      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto" (click)="backToList()">
                        <span class="pi pi-times" style="margin-right:8px;"></span>Cancel
                      </button>
                    </div>
                  </div>
                </div>
              }
            </app-tabpanel>
          </app-tabview>
        </div>
      </div>
    </div>
  }
